import React from 'react';
import './EditLidModal.css';
import { lidStatusOptions } from '../config/formOptions';

/**
 * EditLidModal Component
 * 
 * A modal dialog for adding new or editing existing lid (member) items
 * 
 * @param {boolean} isOpen - Controls modal visibility
 * @param {Function} onClose - Callback when modal should close
 * @param {Function} onSubmit - Callback when form is submitted
 * @param {boolean} isEditMode - Whether the modal is in edit mode
 * @param {Object} formData - Form data state
 * @param {Function} onChange - Handler for form field changes
 * @param {Object} formErrors - Validation errors
 * @param {Function} onDelete - Callback when delete button is clicked (edit mode only)
 */
const EditLidModal = ({
  isOpen,
  onClose,
  onSubmit,
  isEditMode,
  formData,
  onChange,
  formErrors,
  onDelete
}) => {
  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{isEditMode ? 'Lid bewerken' : 'Nieuw lid'}</h3>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>
        
        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="status">Status <span className="required">*</span></label>
              <select
                id="status"
                name="status"
                value={formData.status}
                onChange={onChange}
              >
                <option value="">Selecteer status</option>
                {lidStatusOptions.map(opt => (
                  <option key={opt} value={opt}>{opt}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="aantal">Aantal</label>
              <input
                type="number"
                id="aantal"
                name="aantal"
                value={formData.aantal}
                disabled
                placeholder="Automatisch"
                className={formErrors.aantal ? 'error' : ''}
              />
            </div>
          </div>

          {formData.status === 'Echtpaar' && (
            <p className="hint-message">Vul beide voornamen in bij het veld Voornaam(en)</p>
          )}

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="voornaam">Voornaam(en) <span className="required">*</span></label>
              <input
                type="text"
                id="voornaam"
                name="voornaam"
                value={formData.voornaam}
                onChange={onChange}
                placeholder="'Peter' of 'Peter & Marie'"
                className={formErrors.voornaam ? 'error' : ''}
              />
              {formErrors.voornaam && <span className="error-message">{formErrors.voornaam}</span>}
            </div>
            
            <div className="form-group">
              <label htmlFor="achternaam">Achternaam <span className="required">*</span></label>
              <input
                type="text"
                id="achternaam"
                name="achternaam"
                value={formData.achternaam}
                onChange={onChange}
                placeholder="Familienaam"
                className={formErrors.achternaam ? 'error' : ''}
              />
              {formErrors.achternaam && <span className="error-message">{formErrors.achternaam}</span>}
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email || ''}
                onChange={onChange}
                placeholder="naam@example.com"
              />
            </div>

            <div className="form-group">
              <label htmlFor="telefoon">Telefoonnummer</label>
              <input
                type="tel"
                id="telefoon"
                name="telefoon"
                value={formData.telefoon || ''}
                onChange={onChange}
                placeholder="06 12345678"
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="geboortedatum">Geboortedatum</label>
            <input
              type="date"
              id="geboortedatum"
              name="geboortedatum"
              value={formData.geboortedatum || ''}
              onChange={onChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="bijzonderheden">Bijzonderheden</label>
            <textarea
              id="bijzonderheden"
              name="bijzonderheden"
              value={formData.bijzonderheden}
              onChange={onChange}
              placeholder="Opmerkingen"
              rows="3"
            />
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="button button-secondary"
              onClick={onClose}
            >
              Annuleren
            </button>
            
            {isEditMode && (
              <button
                type="button"
                className="button button-danger"
                onClick={() => {
                  if (window.confirm('Weet u zeker dat u dit lid wilt verwijderen?')) {
                    onDelete();
                  }
                }}
              >
                Verwijderen
              </button>
            )}
            
            <button
              type="submit"
              className="button button-primary"
            >
              {isEditMode ? 'Bijwerken' : 'Toevoegen'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditLidModal;
